/**
 * 项目总览服务
 * 为Dashboard页面提供项目数据和统计信息
 */
import { StatisticsService, DashboardOverviewData } from './statisticsService';

export interface ProjectOverviewData {
  id: string;
  name: string;
  status: string;
  budget: number;
  actualCost: number;
  budgetUsageRate: number | null;
  progress: number;
  startDate: string;
  endDate?: string;
  teamSize: number;
  daysRemaining: number | null;
  scheduleStatusLabel: string;
  recentActivity: string;
  subcontractCost?: number;
  coordinationCost?: number;
  revenueTotal?: number;
  budgetVersion?: number;
  budgetBreakdown?: import('../types').BudgetBreakdown;
  revenueBreakdown?: import('../types').RevenueBreakdown;
  budgetLocked?: boolean;
  budgetLockedAt?: string;
  budgetLockedBy?: { username: string; realName?: string };
  riskTags: string[];
  riskReasons: string[];
  riskScore: number;
  primaryRisk: string | null;
  updatedAt?: string;
}

export class DashboardService {
  /**
   * 获取项目总览数据（使用聚合接口）
   * 一次请求获取所有数据，避免N+1请求问题
   */
  static async getProjectsOverview(): Promise<ProjectOverviewData[]> {
    try {
      const data = await StatisticsService.getDashboardOverview();
      return data.projects;
    } catch (error) {
      console.error('获取项目总览数据失败:', error);
      throw error;
    }
  }

  /**
   * 获取Dashboard完整数据（包含概览统计和项目列表）
   */
  static async getDashboardData(): Promise<DashboardOverviewData> {
    try {
      return await StatisticsService.getDashboardOverview();
    } catch (error) {
      console.error('获取Dashboard数据失败:', error);
      throw error;
    }
  }

  /**
   * 获取项目健康度（预算健康视角）
   */
  static calculateProjectHealth(budget: number, actualCost: number): {
    status: string;
    color: string;
    percentage: number;
  } {
    if (!budget || budget === 0) {
      return { status: '未设置预算', color: '#999', percentage: 0 };
    }

    const percentage = (actualCost / budget) * 100;

    if (percentage <= 70) {
      return { status: '健康', color: '#52c41a', percentage };
    } else if (percentage <= 90) {
      return { status: '良好', color: '#1677ff', percentage };
    } else if (percentage <= 100) {
      return { status: '注意', color: '#fa8c16', percentage };
    } else {
      return { status: '超支', color: '#f5222d', percentage };
    }
  }
}
